import React, { Component } from "react";
import theme from "./toolbox/theme.js";
import ThemeProvider from "react-toolbox/lib/ThemeProvider";
import AppBar from "react-toolbox/lib/app_bar/AppBar";
import { Link } from "react-router-dom";
import Navigation from "react-toolbox/lib/navigation/Navigation";
import "./App.css";
import "./toolbox/theme.css";
import "./brand_theme.css";
import axios from "axios";
import ErrorComponent from "./components/ErrorComponent.js";
import CustomerInfo from "./components/CustomerInfo";
import Signin from "./components/Signin.js";
import Signup from "./components/Signup.js";
import ResetPassword from "./components/ResetPassword.js";
import Contact from "./components/Contact.js";
import Pay from "./components/Pay.js";
import {BrowserRouter as Router, Route, Redirect, Switch} from "react-router-dom";
import PropTypes from "prop-types";
import {delimit} from "./StringUtils.js";

class App extends Component {

	constructor(props) {
		super(props);

		/*
			If the URL to the application is https://hostx.eclipseservices.com/custid/portal/
			then:
			* apiURL = https://hostx.eclipseservices.com/custid/adpro/rs/
			* routingBaseURL = /custid/portal/
			* adproURL = https://hostx.eclipseservices.com/custid/adpro/
		*/
		this.appBaseURL = document.URL;
		this.adproURL = "/adpro/";
		var apiURL = "/adpro/rs/";
		this.routingBaseURL = "";
		if (!this.appBaseURL.includes(":3000")) { //don't do this in local node.js server
			//For the apiURL, get everything up to /portal
			const docURL = this.appBaseURL.endsWith("/") ? this.appBaseURL.substring(0, this.appBaseURL.length - 1) : this.appBaseURL;
			const appSlashPos = docURL.lastIndexOf("/");
			const strippedURL = appSlashPos > -1 ? docURL.substring(0, appSlashPos) : "";
			this.adproURL = strippedURL + this.adproURL;
			apiURL = strippedURL + apiURL;

			//For the routingURL, get the path portion of the document URL
			//Creates a link element and uses that to do the work of parsing the URL.
			//Got the idea from https://www.abeautifulsite.net/parsing-urls-in-javascript
			var parser = document.createElement("a");
			parser.href = this.appBaseURL;
			this.routingBaseURL = parser.pathname;
		}

		this.server = axios.create({
			baseURL: apiURL,
			headers: {
				"Content-Type": "application/json",
				"X-Requested-With": "adpro-web-client"
			},
			timeout: 10000
		});

		this.HomeComponent = this.HomeComponent.bind(this);
		this.reload = this.reload.bind(this);
		this.logout = this.logout.bind(this);

		this.username = "";
		this.password = "";
		this.loginResponseCode = 0;
		this.loginReponseData = {};
		this.loginResponseMsg = "";
		this.login = this.login.bind(this);
		this.setUserID = this.setUserID.bind(this);
		this.setItemsToPay = this.setItemsToPay.bind(this);

		let today = new Date();
		let startDate = new Date(today.getFullYear(), today.getMonth()-1, 1);
		// let endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate()+14);
		let endDate = new Date(today.getFullYear()+1, today.getMonth(), today.getDate()+14);

		//This isn't state because the whole app doesn't need to re-render when
		//this gets changed. Instead, the /pay path will be pushed onto the history
		//when the user is ready to pay, and this will be passed to the payment
		//screen. It should be an object roughly like this:
		/*
			{
				pastDueInvoices: [],
				currentInvoices: [],
				prepaidAds: [],
				billedAds: []
			}
		*/
		//If this is null, then /pay should redirect to /
		this.itemsToPay = null;
		//Same deal, this is just info that gets passed to the payment screen
		//when the user is ready to pay. Comes from the server.
		this.paymentConfig = null;


		this.state = {
			appSettings: null,
			loginState: LoginStates.appInitializing,
			startDate: startDate,
			endDate: endDate,
			loadingState: LoadingStates.inProgress,
			payments: [],
			invoices: [],
			ads:[]
		};
	}

	setItemsToPay(items) {
		this.itemsToPay = items;
	}

	initializeApp() {
		let request = {
			method: "get",
			url: "/signup/publisher",
		};

		this.server(request).then(response => {
			this.setState({appSettings: response.data, loginState: LoginStates.loggedOut});
		}).catch(error => {
			this.loginResponseCode = error.response.status;
			this.loginResponseMsg = "The server returned "+error.response.status+": "+error.response.statusText;
			this.setState({loginState: LoginStates.appInitializationFailed});
		});
	}

	//Called by signup and reset password processes
	//to save the user a little hassle
	setUserID(userID) {
		this.username = userID;
	}

	login(userName, password) {
		//Login uses a different api URL, so it requires a different server object.
		//for this I'm using the global `axios` object.
		let request = {
			method: "post",
			url: this.adproURL + "json-login",
			headers: {
				"Content-Type": "application/json",
				"X-Requested-With": "adpro-web-client"
			},
			timeout: 10000,
			data: {
				username: userName,
				password: password
			}
		};

		this.username = userName;
		this.password = password;

		this.setState({loginState: LoginStates.inProgress});

		axios(request).then(response => {
			this.loginResponseCode = Number(response.status);
			this.loginResponseMsg = "";
			// console.log("Login response data = ", response.data);

			currentUserInfo = new UserInfo(response.data);

			this.setState({ loginState: LoginStates.loggedIn });

			//See `componentDidUpdate` for what happens next
		}).catch(error => {
			if (error.response) {
				//Server returned an error code
				this.loginResponseCode = error.response.status;
				this.loginResponseMsg = "The server returned "+error.response.status+": "+error.response.statusText;
			} else if (error.request) {
				//The request was made, but no response was received.
				this.loginResponseCode = -999;
				this.loginResponseMsg = "The server is not responding. Please try again later.";
			} else {
				//A problem was found in the request before it was sent.
				this.loginResponseCode = -9999;
				this.loginResponseMsg = "Programming Error: "+error.message;
			}
			this.setState({loginState: LoginStates.failed});
		});
	}

	requestTransactionData() {
		let request = {
			method: "post",
			url: "/Statement/transactions",
			data: {
				"beginDate": this.state.startDate.toJSON(),
				"endDate": this.state.endDate.toJSON()
			},
			transformResponse: [data => {
				let dataAsArray = JSON.parse(data);
				return transformDateProps(["transDate", "dueDate", "firstDate", "lastDate"], dataAsArray);
			}]
		};
		// console.log("Getting transaction data for customer");

		this.setState({loadingState: LoadingStates.inProgress});

		//NOTE: The `return` is here because the call returns a Promise that can be used to tell axios to cancel
		//the operation, and also to get notification when all concurrent calls are done. See `componentDidUpdate`
		//for how this is being used.
		return this.server(request).then(response => {
			let invoiceData = response.data.filter(item => {
				return item["@javaType"] === "com.eclipseservices.adpro.ar.InvoiceData";
			});
			let paymentData = response.data.filter(item => {
				return item["@javaType"] === "com.eclipseservices.adpro.ar.CustPaymentData";
			});
			let adData = response.data.filter(item => {
				return item["@javaType"] === "com.eclipseservices.adpro.ar.PrepaidAdSummary";
			});
			let newState = {payments: paymentData, invoices: invoiceData, ads: adData, loadingState: LoadingStates.success };
			this.setState(newState);
			// this.getPaymentConfig();
		}).catch(error => {
			if (error.response) {
				//Server returned an error code
				this.loginResponseCode = error.response.status;
				this.loginResponseMsg = "The server returned "+error.response.status+": "+error.response.statusText;
			} else if (error.request) {
				//The request was made, but no response was received.
				this.loginResponseCode = -999;
				this.loginResponseMsg = "The server is not responding. Please try again later.";
			} else {
				//A problem was found in the request before it was sent.
				this.loginResponseCode = -9999;
				this.loginResponseMsg = "Programming Error: "+error.message;
			}
			let newState = {payments: [], invoices: [], ads: [], loadingState: LoadingStates.failed };
			this.setState(newState);
		});

	}

	getPaymentConfig() {
		let request = {
			method: "get",
			url: "/Payment/config"
		};

		//NOTE: The `return` is here because the call returns the Promise that can be used to tell axios to cancel
		//the operation, and also to get notification when all concurrent calls are done. See `componentDidUpdate`
		//for how this is being used.
		return this.server(request).then(response => {
			this.paymentConfig = response.data;
			this.paymentConfig.appBaseURL = this.appBaseURL;
		}).catch(error => {
			this.paymentConfig = {configError: error};
		});
	}

	reload(keepSelect) {
		if (!keepSelect) {
			this.itemsToPay = null;
		}
		this.setState({ loadingState: LoadingStates.inProgress});
	}

	logout() {
		// this.username = "";
		this.password = "";
		this.itemsToPay = null;
		this.setState({
			loginState: LoginStates.loggedOut,
			loadingState: LoadingStates.success,
			payments: [],
			invoices: [],
			ads: []
		});
	}

	HomeComponent(props) {
		let component;
		switch(this.state.loginState) {
		case LoginStates.appInitializing:
			component = <h1>Initializing...</h1>;
			break;
		case LoginStates.appReloading:
			component = <h1>Loading...</h1>;
			break;
		case LoginStates.appInitializationFailed:
			component = <ErrorComponent processDescription="initializing the application" errorMsg={this.loginResponseMsg}/>;
			break;
		case LoginStates.loggedIn:
			component =
				<CustomerInfo
					loadingState={this.state.loadingState}
					startDate={this.state.startDate}
					invoices={this.state.invoices}
					ads={this.state.ads}
					payments={this.state.payments}
					defaultItemsToPay={this.itemsToPay}
					setItemsToPay={this.setItemsToPay}
					history={props.history}
				/>;
			break;
		default:
			component = <Redirect to="/signin"/>;
		}
		return component;
	}

	componentDidMount() {
		this.initializeApp();
	}

	componentDidUpdate(prevProps, prevState) { // eslint-disable-line no-unused-vars
		if (prevState.loginState === LoginStates.inProgress && this.state.loginState === LoginStates.loggedIn) {
			this.server.defaults.auth = {
				username: this.username,
				password: this.password
			};
			//This is how you manage multiple current async requests in axios.
			//I don't think it is necessary to call axios.all in this case,
			//but I'm doing it in case I need to manange them later.
			axios.all([this.requestTransactionData(), this.getPaymentConfig()]);
		} else if (prevState.loadingState === LoadingStates.success && this.state.loadingState === LoadingStates.inProgress) {
			this.requestTransactionData();
		}
	}

	render() {
		let title;
		if (this.state.loginState === LoginStates.appInitializing) {
			title = "";
		} else if (this.state.loginState === LoginStates.appInitializationFailed) {
			title = "";
		} else {
			title = this.state.appSettings["publisher.name"];
		}

		return (
			<Router basename={this.routingBaseURL}>
				<ThemeProvider theme={theme}>
					<div className="App">
						<AppBar title={title}>
							<Navigation type="horizontal">
								{this.state.loginState === LoginStates.loggedIn ? <Link to="/logout">Sign Out</Link> : null}
							</Navigation>
						</AppBar>

						<Switch>
							<Route exact path="/" component={this.HomeComponent} />
							<Route path="/signin" render={() =>
								this.state.loginState === LoginStates.loggedIn ?
									<Redirect to="/"/> :
									<Signin
										loginState={this.state.loginState}
										loginFunction={this.login}
										lastResultCode={this.loginResponseCode}
										lastResultDetail={this.loginResponseMsg}
										defaultUserID={this.username}
									/>
							}/>
							<Route path="/signup" render={(props) =>
								<Signup
									appSettings={this.state.appSettings}
									history={props.history}
									server={this.server}
									setUserIDAction={this.setUserID}
								/>}
							/>
							<Route path="/resetpassword" render={(props) =>
								<ResetPassword
									history={props.history}
									server={this.server}
									setUserIDAction={this.setUserID}
								/>}
							/>
							<Route path="/contact" render={() =>
								<Contact
									appSettings={this.state.appSettings}
								/>}
							/>
							<Route path="/pay" render={(props) =>
								this.itemsToPay ?
									<Pay
										itemsToPay={this.itemsToPay}
										paymentConfig={this.paymentConfig}
										server={this.server}
										routerHistory={props.history}
									/> :
									<Redirect to="/"/>
							}/>
							<Route path="/reload" render={() => {
								//eslint-disable-next-line no-restricted-globals
								let params = new URLSearchParams(location.search);
								let keepSelectVal = params.get("keepSelect");
								let keepSelect = keepSelectVal ? keepSelectVal === "y" : false;
								return <Reload reload={this.reload} keepSelect={keepSelect}/>;
							}}/>
							<Route path="/logout" render={() => {
								// this.password = null;
								// return <Redirect to="/signin"/>;
								return <Logout logout={this.logout}/>;
							}}/>
						</Switch>
					</div>
				</ThemeProvider>
			</Router>
		);
	}
}

export class UserInfo {

	constructor(custData) {
		this.customerNumber = custData.companyRef;
		this.customerName = custData.companyName;
		this.customerStreet = custData.street;
		this.customerSuite = custData.apartment;
		this.customerCity = custData.city;
		this.customerState = custData.state;
		this.customerZip = custData.zipCode;
		this.customerPhone = custData.phone;
		this.customerEmail = custData.email;

		this.userFullName = custData.userFullName;
		this.billContact = custData.billContact;
	}

	numberAndName() {
		return delimit(this.customerNumber, this.customerName, ": ");
	}

	// eslint-disable-next-line no-unused-vars
	jsxNameAddress(props) {
		let cityState = delimit(this.customerCity, this.customerState, ", ");
		let cityStateZip = delimit(cityState, this.customerZip, " ");
		return (
			<div className="UserInfo_NameAddress">
				{this.numberAndName()}<br/>
				Attention: {this.userFullName}<br/>
				{this.customerStreet}<br/>
				{delimit(this.customerSuite, "", <br/>)}
				{cityStateZip}<br/>
			</div>
		);
	}

}

export let currentUserInfo = null;

//This is handled with a compenent so it can be triggered with a URL.
class Reload extends Component {
	render() {
		return <Redirect to="/"/>;
	}

	componentDidMount() {
		this.props.reload(this.props.keepSelect);
	}
}

Reload.propTypes = {
	reload: PropTypes.func,
	keepSelect: PropTypes.bool
};

class Logout extends Component {
	constructor(props) {
		super(props);
		this.state = {renders: 0};
	}


	render() {
		if (this.state.renders === 0) {
			return <h2>Logging Out...</h2>;
		} else {
			return <Redirect to="/signin"/>;
		}
	}

	componentDidMount() {
		if (this.state.renders === 0) {
			this.props.logout();
			this.setState({ renders: 1 });
		}
	}
}

Logout.propTypes = {
	logout: PropTypes.func
};

// This is from
// https://stackoverflow.com/questions/149055/how-can-i-format-numbers-as-dollars-currency-string-in-javascript
Number.prototype.formatMoney = function(precision, decSep, thouSep){ // eslint-disable-line no-extend-native
	var n = this,
		c = isNaN(precision = Math.abs(precision)) ? 2 : precision,
		d = decSep === undefined ? "." : decSep,
		t = thouSep === undefined ? "," : thouSep,
		s = n < 0 ? "-$" : "$",
		i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c), 10)),
		l = i.length,
		j = l > 3 ? l % 3 : 0;
	return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
};

// Returns a new date object with the time set to 00:00:00
Date.prototype.toDateWithoutTime = function() { // eslint-disable-line no-extend-native
	return new Date(this.getYear(), this.getMonth(), this.getDate());
};

export const LoadingStates = {
	inProgress: 1,
	success: 2,
	failed: 3
};

export const LoginStates = {
	loggedOut: 1,
	inProgress: 2,
	failed: 3,
	signUpStart: 10,
	signUpChallenge: 11,
	signUpFailed: 12,
	signUpComplete: 13,
	loggedIn: 100,
	appInitializing: 1000,
	appInitializationFailed: 1010
};

function transformDateProps(dateProps, data) {
	data = data.map(trans => dateConverter(dateProps, trans));
	return data;
}

function dateConverter(dateProps, transaction) {
	dateProps.forEach(dateProp => {
		var dateStr = transaction[dateProp];
		if (dateStr != null && dateStr !== "") {
			let p =  dateStr.split(/\D/).map(i => Number.parseInt(i, 10));
			//To get the time zone correct, adjust to UTC
			if (dateStr.indexOf("+") > 0) {
				p[3] = p[3] - p[7]/100;
			} else {
				p[3] = p[3] + p[7]/100;
			}
			//Need to use Date.UTC because using just Date() assumes time is
			//in the current time-zone, which may not be true.
			let date = new Date(Date.UTC(p[0], p[1]-1, p[2], p[3], p[4], p[5], p[6]));
			if (date != null) {
				transaction[dateProp] = date;
			}
		}
	});
	return transaction;
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js